import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCMSAuth } from '@/contexts/CMSAuthContext';

interface ProtectedCMSRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

export const ProtectedCMSRoute: React.FC<ProtectedCMSRouteProps> = ({ 
  children, 
  requiredPermission 
}) => {
  const { user, isLoading, hasRole } = useCMSAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/cms/login" state={{ from: location }} replace />;
  }

  // Check if user has required role (treat requiredPermission as role check)
  if (requiredPermission && !hasRole(requiredPermission)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-4">Access Denied</h1>
          <p className="text-[hsl(var(--fg-muted))]">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};